import { isEmpty, capitalize } from 'lodash'
import { TransferDirection, TransferType, IraDistributionDetails, IraContributionDetails } from '@Types'

const directionOptions = ['DEPOSIT', 'WITHDRAWAL']
const transferOptions = ['ACH', 'WIRE', 'CASH_JOURNAL', 'CHECK']

export const getTransferDirection = (
  direction: TransferDirection,
  transferType: TransferType,
  iraDistributionDetails?: IraDistributionDetails,
  iraContributionDetails?: IraContributionDetails,
  searchAccount?: string,
  sourceAccount?: string,
  destinationAccount?: string
) => {
  const isIraDistribution = !isEmpty(iraDistributionDetails) && (direction === 'WITHDRAWAL' || direction === 'JOURNAL')
  const isIraContribution = !isEmpty(iraContributionDetails) && (direction === 'DEPOSIT' || direction === 'JOURNAL')
  const isJournalJournal = transferType === 'CASH_JOURNAL' && direction === 'JOURNAL'

  if (isIraDistribution) {
    return `IRA Distribution`
  }

  if (isIraContribution) {
    return `IRA Contribution`
  }

  if (isJournalJournal) {
    const isDebit = searchAccount && sourceAccount && searchAccount === sourceAccount
    const isCredit = searchAccount && destinationAccount && searchAccount === destinationAccount
    if (isDebit) {
      return 'Debit'
    }
    if (isCredit) {
      return 'Credit'
    }
    // Cash_Journal direction unknown
    return ''
  }
  // Transfer type is recognized but Direction is NOT recognized
  if (transferOptions.includes(transferType) && !directionOptions.includes(direction)) {
    return 'Transfer'
  }

  // Transfer type is recognized
  if (!transferOptions.includes(transferType)) {
    return 'Type'
  }
  // Normal transfer direction
  return `${capitalize(direction)}`
}
